/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScriptTypeEnum } from './scriptTypeEnum';
import { ScriptManifest } from './scriptManifest';


export interface ScriptRegistryEntryDto { 
    /**
     * Unique human-readable script identifier (e.g. aws-ebs-snapshot-cleanup)
     */
    id: string;
    /**
     * Display name shown in the UI
     */
    name?: string;
    /**
     * Human-readable description of what the script does
     */
    description?: string;
    /**
     * Relative S3 path where the script artifact is stored
     */
    storage_location?: string;
    script_type?: ScriptTypeEnum;
    /**
     * Whether this script runs on SSM-managed EC2 instances (true) or VCF ACC (false)
     */
    executes_on_managed_instances?: boolean;
    /**
     * Supported cloud providers (e.g. AWS, GCP)
     */
    target_cloud?: Array<string>;
    /**
     * Applicable service types (e.g. VCDR)
     */
    service_type?: Array<string>;
    /**
     * RBAC role names permitted to invoke this script
     */
    roles?: Array<string>;
    /**
     * Product components this script applies to (e.g. IRR, CDVX)
     */
    components?: Array<string>;
    /**
     * Supported product/component version strings
     */
    supported_versions?: Array<string>;
    /**
     * JSON string describing the script accepted parameter definitions
     */
    parameters?: string;
    /**
     * Whether this script is active and eligible for execution
     */
    enabled: boolean;
    /**
     * JSON Schema blob describing the structure of this script output
     */
    output_json_schema?: { [key: string]: any; };
    metadata?: ScriptManifest;
    /**
     * Last-modified timestamp of the manifest file in S3
     */
    source_modified_ts?: Date;
    created_ts?: Date;
    created_by?: string;
    updated_ts?: Date;
    updated_by?: string;
}
export namespace ScriptRegistryEntryDto {
}


